{
    "ShowMore": "Laat meer zien",
    "ShowLess": "Laat minder zien",
    "NAME": "LanguageSnackbar"
}